/**
 * PublicLinkButton — opens the public-facing page of an entity (event/news/member)
 * in a new tab. Useful from admin/member/press views to preview what visitors see.
 *
 * Usage:
 *   <PublicLinkButton slug={ev.slug} type="event" label="Voir la page publique" />
 *   <PublicLinkButton slug={n.slug} type="news" compact />
 */
import { ExternalLink } from "lucide-react";

const PATHS = {
  event: "/events/",
  news: "/news/",
  member: "/members/",
};

export default function PublicLinkButton({ slug, type = "event", label, compact = false, className = "" }) {
  if (!slug) return null;
  const href = `${PATHS[type] || "/"}${slug}`;
  const text = label || (type === "event" ? "Voir la page publique" : type === "news" ? "Voir l'article public" : "Voir la fiche publique");
  if (compact) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        title={text}
        onClick={(e) => e.stopPropagation()}
        className={`grid h-7 w-7 place-items-center rounded-full text-neutral-500 hover:bg-wine-50 hover:text-wine-700 ${className}`}
        data-testid={`public-link-${type}-${slug}`}
      >
        <ExternalLink className="h-3.5 w-3.5" />
      </a>
    );
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => e.stopPropagation()}
      className={`inline-flex items-center gap-1.5 rounded-full border border-wine-200 bg-white px-3 py-1.5 text-xs font-semibold text-wine-700 hover:border-wine-400 hover:bg-wine-50 ${className}`}
      data-testid={`public-link-${type}-${slug}`}
    >
      <ExternalLink className="h-3.5 w-3.5" />
      {text}
    </a>
  );
}
